function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint indent: ["off"] */
import $ from 'dom7';
import { window, document } from 'ssr-window';
import Utils from '../../utils/utils';
import Modal from '../modal/modal-class';

var Actions = /*#__PURE__*/function (_Modal) {
  _inherits(Actions, _Modal);

  var _super = _createSuper(Actions);

  function Actions(app, params) {
    var _this;

    _classCallCheck(this, Actions);

    var extendedParams = Utils.extend({
      on: {}
    }, app.params.actions, params); // Extends with open/close Modal methods;

    _this = _super.call(this, app, extendedParams);

    var actions = _assertThisInitialized(_this);

    actions.params = extendedParams; // Buttons

    var groups;

    if (actions.params.buttons) {
      groups = actions.params.buttons;
      if (!Array.isArray(groups[0])) groups = [groups];
    }

    actions.groups = groups; // Find Element

    var $el;

    if (actions.params.el) {
      $el = $(actions.params.el).eq(0);
    } else if (actions.params.content) {
      $el = $(actions.params.content).filter(function (elIndex, node) {
        return node.nodeType === 1;
      }).eq(0);
    } else if (actions.params.buttons) {
      if (actions.params.convertToPopover) {
        actions.popoverHtml = actions.renderPopover();
      }

      actions.actionsHtml = actions.render();
    }

    if ($el && $el.length > 0 && $el[0].f7Modal) {
      return _possibleConstructorReturn(_this, $el[0].f7Modal);
    }

    if ($el && $el.length === 0 && !(actions.actionsHtml || actions.popoverHtml)) {
      return _possibleConstructorReturn(_this, actions.destroy());
    } // Backdrop


    var $backdropEl;

    if (actions.params.backdrop && actions.params.backdropEl) {
      $backdropEl = $(actions.params.backdropEl);
    } else if (actions.params.backdrop) {
      $backdropEl = app.root.children('.actions-backdrop');

      if ($backdropEl.length === 0) {
        $backdropEl = $('<div class="actions-backdrop"></div>');
        app.root.append($backdropEl);
      }
    }

    var originalOpen = actions.open;
    var originalClose = actions.close;
    var popover;

    function buttonOnClick(e) {
      var $buttonEl = $(this);
      var buttonIndex;
      var groupIndex;

      if ($buttonEl.hasClass('list-button') || $buttonEl.hasClass('item-link')) {
        buttonIndex = $buttonEl.parents('li').index();
        groupIndex = $buttonEl.parents('.list').index();
      } else {
        buttonIndex = $buttonEl.index();
        groupIndex = $buttonEl.parents('.actions-group').index();
      }

      if (typeof groups !== 'undefined') {
        var button = groups[groupIndex][buttonIndex];
        if (button.onClick) button.onClick(actions, e);
        if (actions.params.onClick) actions.params.onClick(actions, e);
        if (button.close !== false) actions.close();
      }
    }

    actions.open = function open(animate) {
      var convertToPopover = false;
      var _actions$params = actions.params,
          targetEl = _actions$params.targetEl,
          targetX = _actions$params.targetX,
          targetY = _actions$params.targetY,
          targetWidth = _actions$params.targetWidth,
          targetHeight = _actions$params.targetHeight;

      if (actions.params.convertToPopover && (targetEl || targetX !== undefined && targetY !== undefined)) {
        // Popover
        if (actions.params.forceToPopover || app.device.ios && app.device.ipad || app.width >= 768 || app.device.desktop && app.theme === 'aurora') {
          convertToPopover = true;
        }
      }

      if (convertToPopover && actions.popoverHtml) {
        popover = app.popover.create({
          content: actions.popoverHtml,
          backdrop: actions.params.backdrop,
          targetEl: targetEl,
          targetX: targetX,
          targetY: targetY,
          targetWidth: targetWidth,
          targetHeight: targetHeight,
          on: {
            open: function open() {
              if (!actions.$el) {
                actions.$el = popover.$el;
              }

              actions.$el.trigger("modal:open ".concat(actions.type.toLowerCase(), ":open"));
              actions.emit("local::open modalOpen ".concat(actions.type, "Open"), actions);
            },
            opened: function opened() {
              if (!actions.$el) {
                actions.$el = popover.$el;
              }

              actions.$el.trigger("modal:opened ".concat(actions.type.toLowerCase(), ":opened"));
              actions.emit("local::opened modalOpened ".concat(actions.type, "Opened"), actions);
            },
            close: function close() {
              if (!actions.$el) {
                actions.$el = popover.$el;
              }

              actions.$el.trigger("modal:close ".concat(actions.type.toLowerCase(), ":close"));
              actions.emit("local::close modalClose ".concat(actions.type, "Close"), actions);
            },
            closed: function closed() {
              if (!actions.$el) {
                actions.$el = popover.$el;
              }

              actions.$el.trigger("modal:closed ".concat(actions.type.toLowerCase(), ":closed"));
              actions.emit("local::closed modalClosed ".concat(actions.type, "Closed"), actions);
            }
          }
        });
        popover.open(animate);
        popover.once('popoverOpened', function () {
          popover.$el.find('.list-button, .item-link').each(function (groupIndex, buttonEl) {
            $(buttonEl).on('click', buttonOnClick);
          });
        });
        popover.once('popoverClosed', function () {
          popover.$el.find('.list-button, .item-link').each(function (groupIndex, buttonEl) {
            $(buttonEl).off('click', buttonOnClick);
          });
          Utils.nextTick(function () {
            popover.destroy();
            popover = undefined;
          });
        });
      } else {
        actions.$el = actions.actionsHtml ? $(actions.actionsHtml) : actions.$el;
        actions.$el[0].f7Modal = actions;

        if (actions.groups) {
          actions.$el.find('.actions-button').each(function (groupIndex, buttonEl) {
            $(buttonEl).on('click', buttonOnClick);
          });
          actions.once('actionsClosed', function () {
            actions.$el.find('.actions-button').each(function (groupIndex, buttonEl) {
              $(buttonEl).off('click', buttonOnClick);
            });
          });
        }

        actions.el = actions.$el[0];
        originalOpen.call(actions, animate);
      }

      return actions;
    };

    actions.close = function close(animate) {
      if (popover) {
        popover.close(animate);
      } else {
        originalClose.call(actions, animate);
      }

      return actions;
    };

    Utils.extend(actions, {
      app: app,
      $el: $el,
      el: $el ? $el[0] : undefined,
      $backdropEl: $backdropEl,
      backdropEl: $backdropEl && $backdropEl[0],
      type: 'actions'
    });

    function handleClick(e) {
      var target = e.target;
      var $target = $(target);
      var keyboardOpened = !app.device.desktop && app.device.cordova && (window.Keyboard && window.Keyboard.isVisible || window.cordova.plugins && window.cordova.plugins.Keyboard && window.cordova.plugins.Keyboard.isVisible);
      if (keyboardOpened) return;

      if ($target.closest(actions.el).length === 0) {
        if (actions.params.closeByBackdropClick && actions.params.backdrop && actions.backdropEl && actions.backdropEl === target) {
          actions.close();
        } else if (actions.params.closeByOutsideClick) {
          actions.close();
        }
      }
    }

    function onKeyDown(e) {
      var keyCode = e.keyCode;

      if (keyCode === 27 && actions.params.closeOnEscape) {
        actions.close();
      }
    }

    if (actions.params.closeOnEscape) {
      actions.on('open', function () {
        $(document).on('keydown', onKeyDown);
      });
      actions.on('close', function () {
        $(document).off('keydown', onKeyDown);
      });
    }

    actions.on('opened', function () {
      if (actions.params.closeByBackdropClick || actions.params.closeByOutsideClick) {
        app.on('click', handleClick);
      }
    });
    actions.on('close', function () {
      if (actions.params.closeByBackdropClick || actions.params.closeByOutsideClick) {
        app.off('click', handleClick);
      }
    });

    if ($el) {
      $el[0].f7Modal = actions;
    }

    return _possibleConstructorReturn(_this, actions);
  }

  _createClass(Actions, [{
    key: "render",
    value: function render() {
      var actions = this;
      if (actions.params.render) return actions.params.render.call(actions, actions);
      var groups = actions.groups;
      var cssClass = actions.params.cssClass;
      return "\n      <div class=\"actions-modal".concat(actions.params.grid ? ' actions-grid' : '', " ").concat(cssClass || '', "\">\n        ").concat(groups.map(function (group) {
        return "<div class=\"actions-group\">\n            ".concat(group.map(function (button) {
          var buttonClasses = ["actions-".concat(button.label ? 'label' : 'button')];
          var color = button.color,
              bg = button.bg,
              bold = button.bold,
              disabled = button.disabled,
              label = button.label,
              text = button.text,
              icon = button.icon;
          if (color) buttonClasses.push("color-".concat(color));
          if (bg) buttonClasses.push("bg-color-".concat(bg));
          if (bold) buttonClasses.push('actions-button-bold');
          if (disabled) buttonClasses.push('disabled');

          if (label) {
            return "<div class=\"".concat(buttonClasses.join(' '), "\">").concat(text, "</div>");
          }

          return "\n                <div class=\"".concat(buttonClasses.join(' '), "\">\n                  ").concat(icon ? "<div class=\"actions-button-media\">".concat(icon, "</div>") : '', "\n                  <div class=\"actions-button-text\">").concat(text, "</div>\n                </div>").trim();
        }).join(''), "\n          </div>");
      }).join(''), "\n      </div>\n    ").trim();
    }
  }, {
    key: "renderPopover",
    value: function renderPopover() {
      var actions = this;
      if (actions.params.renderPopover) return actions.params.renderPopover.call(actions, actions);
      var groups = actions.groups;
      var cssClass = actions.params.cssClass;
      return "\n      <div class=\"popover popover-from-actions ".concat(cssClass || '', "\">\n        <div class=\"popover-inner\">\n          ").concat(groups.map(function (group) {
        return "\n            <div class=\"list\">\n              <ul>\n                ".concat(group.map(function (button) {
          var itemClasses = [];
          var color = button.color,
              bg = button.bg,
              bold = button.bold,
              disabled = button.disabled,
              label = button.label,
              text = button.text,
              icon = button.icon;
          if (color) itemClasses.push("color-".concat(color));
          if (bg) itemClasses.push("bg-color-".concat(bg));
          if (bold) itemClasses.push('popover-from-actions-bold');
          if (disabled) itemClasses.push('disabled');

          if (label) {
            itemClasses.push('popover-from-actions-label');
            return "<li class=\"".concat(itemClasses.join(' '), "\">").concat(text, "</li>");
          }

          if (icon) {
            itemClasses.push('item-link item-content');
            return "\n                      <li>\n                        <a class=\"".concat(itemClasses.join(' '), "\">\n                          <div class=\"item-media\">\n                            ").concat(icon, "\n                          </div>\n                          <div class=\"item-inner\">\n                            <div class=\"item-title\">\n                              ").concat(text, "\n                            </div>\n                          </div>\n                        </a>\n                      </li>\n                    ");
          }

          itemClasses.push('list-button');
          return "\n                    <li>\n                      <a class=\"".concat(itemClasses.join(' '), "\">").concat(text, "</a>\n                    </li>\n                  ");
        }).join(''), "\n              </ul>\n            </div>\n          ");
      }).join(''), "\n        </div>\n      </div>\n    ").trim();
    }
  }]);

  return Actions;
}(Modal);

export default Actions;